import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import DataTable, { ExpanderComponentProps, createTheme } from "react-data-table-component";
import * as styleTable from "styles/datatable";
import Datatablenoresults from "layouts/Datatablenoresults";
import CheckboxTable from "fragments/CheckboxTable";
var paginationComponentOptions = {
    rowsPerPageText: "จำนวนรายการต่อหน้า",
    rangeSeparatorText: "of",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Todos"
};
var customStyles = {
    rows: {
        style: {
            minHeight: "52px"
        }
    },
    headCells: {
        style: {
            paddingLeft: "15px",
            paddingRight: "15px",
            color: "rgba(76, 78, 100, 0.87)",
            fontFamily: "Sarabun",
            fontSize: "16px",
            background: "rgb(245, 245, 247)",
            paddingTop: "15px",
            paddingBottom: "15px"
        }
    },
    cells: {
        style: {
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingTop: "10px",
            paddingBottom: "10px",
            color: "rgba(76, 78, 100, 0.87)",
            fontFamily: "Sarabun",
            fontSize: "16px",
            fontWeight: "300"
        }
    }
};
createTheme("solarized", {
    background: {
        default: "#B0041221"
    },
    text: {
        primary: "#268bd2",
        secondary: "#2aa198"
    }
});
export default function RowExpansion(_param) {
    var data = _param.data, dataDetail = _param.dataDetail, handleRowSelected = _param.handleRowSelected, columns = _param.columns, columnsDetail = _param.columnsDetail, isSelectRows = _param.isSelectRows, _param_PerPage = _param.PerPage, PerPage = _param_PerPage === void 0 ? 10 : _param_PerPage, props = _object_without_properties(_param, [
        "data",
        "dataDetail",
        "handleRowSelected",
        "columns",
        "columnsDetail",
        "isSelectRows",
        "PerPage"
    ]);
    var ExpandedComponent = function(val) {
        return /*#__PURE__*/ _jsx(DataTable, {
            columns: columnsDetail,
            // theme="solarized"
            data: val.data.PdPdetail
        });
    };
    return /*#__PURE__*/ _jsx(DataTable, {
        columns: columns,
        data: data,
        expandableRows: true,
        expandableRowsComponent: ExpandedComponent,
        customStyles: customStyles,
        selectableRows: isSelectRows,
        selectableRowsComponent: CheckboxTable,
        pagination: true,
        paginationComponentOptions: paginationComponentOptions,
        onSelectedRowsChange: handleRowSelected,
        noDataComponent: /*#__PURE__*/ _jsx(Datatablenoresults, {}),
        persistTableHead: true,
        paginationPerPage: PerPage,
        paginationRowsPerPageOptions: [
            5,
            10,
            25,
            50,
            100
        ]
    });
}
